import React from 'react';

import { AlertDescription, AlertTitle, Icon, Stack } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export const TranscriptionWarning: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Stack
      align="start"
      className="pt-5 text-text-secondary"
      gap={2}
      direction="horizontal"
      role="alert"
    >
      <div className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-full bg-bg-secondary">
        <Icon name="Info" size="md" aria-hidden="true" />
      </div>
      <div className="min-w-0 pt-0.5">
        <AlertTitle className="text-sm text-text-primary">
          {t('blocks.transcriptionWarning.title')}
        </AlertTitle>
        <AlertDescription className="leading-5">
          {t('blocks.transcriptionWarning.description')}
        </AlertDescription>
      </div>
    </Stack>
  );
};
